import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyAction, LazyModule } from 'owa-bundling';
import { getAdContentSharingConsentStore } from './store/store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "AdContentSharingConsent" */ './lazyIndex'),
    { name: 'AdContentSharingConsent' }
);

export const lazyInitializeAdContentSharingConsentDialog: LazyAction<
    typeof lazyIndex.initializeAdContentSharingConsentDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeAdContentSharingConsentDialog);

export const AdContentSharingConsentDialog: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.AdContentSharingConsentSurfaces,
    undefined,
    undefined,
    {
        onlyImportIf: () => {
            const store = getAdContentSharingConsentStore();
            return !!store.visibleSurface;
        },
    }
);
